import { render, staticRenderFns } from "./InputNumberFormItem.vue?vue&type=template&id=21b45b6a&"
import script from "./InputNumberFormItem.vue?vue&type=script&lang=js&"
export * from "./InputNumberFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports